import _ from "lodash";
import { useEffect } from "react";
import { connect } from "react-redux";

import { BellAlertIcon, BuildingOffice2Icon, UserCircleIcon, ViewColumnsIcon } from "@heroicons/react/20/solid";
import { Actions as NOTIFICATION_ACTIONS } from "../../store/actions/notificationActions";
// import InvalidPermissions from "../company-pages/InvalidPermissions";
import NotificationRow from "./NotificationRow";
import { SectionIcons as Icons } from "./NotificationIcons";
import NotificationSync from "./NotificationSync";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const Notifications = ({ notifications, getNotifications, org, advisor, user }) => {
	useEffect(() => {
		if (!notifications) getNotifications();
	}, [org, advisor, user]);
	// if (userPermissions == "None") return <InvalidPermissions />;
	const location = useLocation();
	const currentTab = location.pathname;

	const isAdvisor = currentTab.includes("advisor");
	const isOrganisation = currentTab.includes("organisation");
	const isUser = currentTab.includes("user");

	const notificationsPerTab = useMemo(() => {
		const perTab = { advisor: 0, organisation: 0, user: 0 };
		for (const item of notifications || []) {
			if (item.read) continue;
			if (item.advisor) perTab.advisor++;
			if (item.company) perTab.organisation++;
			if (item.userId) perTab.user++;
		}

		return perTab;
	}, [JSON.stringify(notifications)]);

	const tabs = useMemo(() => {
		const tabs = [
			{
				link: "/organisation/notifications",
				name: (
					<>
						<BuildingOffice2Icon
							className="h-7 w-7"
							style={{ verticalAlign: "sub" }}
						/>{" "}
						Organisation Inbox
					</>
				),
				show: ({ org }) => !!org,
				hasNotifications: notificationsPerTab.organisation,
			},
			{
				link: "/advisor/notifications",
				name: (
					<>
						<ViewColumnsIcon
							className="h-7 w-7"
							style={{ verticalAlign: "sub" }}
						/>{" "}
						Advisor Inbox
					</>
				),
				show: ({ advisor }) => !!advisor,
				hasNotifications: notificationsPerTab.advisor,
			},
			{
				link: "/user/notifications",
				name: (
					<>
						<UserCircleIcon
							className="h-7 w-7"
							style={{ verticalAlign: "sub" }}
						/>{" "}
						My Inbox
					</>
				),
				hasNotifications: notificationsPerTab.user,
			},
		];

		return tabs.filter((tab) => (tab.show ? tab.show({ org, advisor }) : true));
	}, [org, advisor, JSON.stringify(notificationsPerTab)]);

	const notificationSections = useMemo(() => {
		const notificationList = notifications?.filter((item) => {
			if (isAdvisor) return !!item.advisor;
			if (isOrganisation) return !!item.company;
			if (isUser) return !!item.userId;
		});
		const notificationSections = notificationList?.reduce((prev, curr) => {
			if (!prev[curr.source]) prev[curr.source] = [];
			prev[curr.source].push(curr);
			return prev;
		}, {});

		return Object.entries({ ...notificationSections });
	}, [JSON.stringify(notifications), currentTab]);

	return (
		<>
			<div className="content">
				<div className="row">
					<div className="col-xs-12">
						<div className="pull-left">
							<h1 className="page-heading">Notifications</h1>
						</div>
						<NotificationSync />
					</div>
				</div>
			</div>

			<ul className="nav nav-tabs nav-tabs-alt nav-justified">
				{tabs.map((tab) => {
					return (
						<li className={currentTab === tab.link ? "active" : ""}>
							<Link to={tab.link}>
								{tab.name}{" "}
								{tab?.hasNotifications ? (
									<BellAlertIcon
										className="h-5 w-5"
										style={{ marginLeft: 5 }}
									/>
								) : null}
							</Link>
						</li>
					);
				})}
			</ul>

			<div className="content mb-20">
				{notificationSections?.length > 0 &&
					notificationSections?.map(([title, entries], index) => {
						const Icon = Icons[title];
						const notifications = _.orderBy(entries, ["read", "updatedAt", "title"], ["asc", "asc", "asc"]);
						const notificationsRead = notifications?.filter((item) => !item.read)?.length;
						const addMargin = index % 2 != 0 ? "pr-0" : "";
						return (
							<div
								className={`${
									notificationSections?.length > 1 ? "col-lg-6" : ""
								} pl-0 ${addMargin} col-xs-12 `}
							>
								<div
									className="col-xs-12 form-section"
									style={{ paddingRight: "3rem" }}
								>
									<h3 style={{ margin: "1rem" }}>
										{Icon ? <Icon /> : null}
										{title}
										{notificationsRead ? (
											<div
												className="pull-right"
												style={{
													marginLeft: "2rem",
													background: notificationsRead > 0 ? "#ea611c" : "white",
													color: notificationsRead > 0 ? "white" : "black",
													display: "block",
													borderRadius: "3rem",
													paddingTop: "0.5rem",
													fontSize: "1.5rem",
													width: "3rem",
													height: "3rem",
													textAlign: "center",
												}}
											>
												{notificationsRead > 99 ? "99+" : notificationsRead}
											</div>
										) : null}
									</h3>
									<div
										className="col-xs-12 form-inner-section"
										style={{ padding: "1.5rem" }}
									>
										{notifications?.map((item) => (
											<NotificationRow notification={item} />
										))}
									</div>
								</div>
							</div>
						);
					})}
				{notificationSections?.length <= 0 && (
					<div
						className="block text-center bg-white"
						style={{ paddingTop: 120 }}
					>
						<div id="all-done">
							<div
								className="item item-circle bg-primary"
								style={{ position: "relative", height: "12rem", width: "12rem" }}
							>
								<BellAlertIcon
									style={{
										position: "absolute",
										height: "10rem",
										color: "white",
										right: "1rem",
										top: "1rem",
									}}
								/>
								{/* <CurrencyEuroIcon style={{ position: 'absolute', height: '5rem', color: '#ea611c', right: '0rem', top: '6rem', background: 'white', borderRadius: '5rem' }} /> */}
							</div>
							<div className="main">
								<h1 className="font-w700 text-center">You're all caught up!</h1>
								<h4 className="text-center">There are no new notifications at the moment.</h4>
								<p className="text-center">
									Once you've received new notifications, you'll be notified and notifications will
									appear on this page.
								</p>
							</div>
						</div>
					</div>
				)}
				<div className="clearfix" />
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const notificationsList = state.notifications?.list || [];
	const integrationNotifications = state.notifications?.integrations || [];
	const notifications = [...notificationsList, ...integrationNotifications];

	return {
		notification: state.notifications?.notification,
		notifications,
		org: state.company?.settings?.org,
		advisor: state.my?.profile?.advisorId,
		user: state.my?.profile?.id,
	};
};

const mapDispatchToProps = (dispatch) => ({
	clearNotification: () => dispatch(NOTIFICATION_ACTIONS.getNotification()),
	getNotifications: () => dispatch(NOTIFICATION_ACTIONS.getNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
